import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Avatar } from "./Avatar";
import { Leaf, SignOut, User, ShieldCheck, Heart } from "@phosphor-icons/react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "./ui/dropdown-menu";
import { TrialNudge } from "./Paywall";

export const Navbar = () => {
  const { user, sub, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <>
      <header className="sticky top-0 z-50 bg-[#FDFBF7]/80 backdrop-blur-md border-b border-[#EAE6D9]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
          <div className="w-9 h-9 rounded-full bg-[#8A9A86] flex items-center justify-center group-hover:rotate-12 transition-transform duration-300">
            <Leaf size={20} weight="fill" color="#fff" />
          </div>
          <span className="font-heading text-2xl font-semibold text-[#2C362B]">The Safe Space</span>
        </Link>

        {user && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className="flex items-center gap-2 hover:bg-[#F4F1E8] rounded-full pl-2 pr-3 py-1.5 transition-colors" data-testid="user-menu-trigger">
                <Avatar handle={user.handle} size={32} />
                <span className="text-sm font-semibold text-[#414C3F] hidden sm:block">{user.handle}</span>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="rounded-2xl border-[#EAE6D9] w-48">
              <DropdownMenuItem className="rounded-xl cursor-pointer" onClick={() => navigate("/profile")} data-testid="menu-profile">
                <User size={18} weight="duotone" className="mr-2" /> My Space
              </DropdownMenuItem>
              <DropdownMenuItem className="rounded-xl cursor-pointer" onClick={() => navigate("/subscribe")} data-testid="menu-subscribe">
                <Heart size={18} weight="duotone" className="mr-2" /> Membership
              </DropdownMenuItem>
              {user.role === "admin" && (
                <DropdownMenuItem className="rounded-xl cursor-pointer" onClick={() => navigate("/admin")} data-testid="menu-admin">
                  <ShieldCheck size={18} weight="duotone" className="mr-2" /> Moderation
                </DropdownMenuItem>
              )}
              <DropdownMenuSeparator />
              <DropdownMenuItem className="rounded-xl cursor-pointer text-[#D97B6A]" onClick={logout} data-testid="menu-logout">
                <SignOut size={18} weight="duotone" className="mr-2" /> Sign out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </div>
    </header>
      <TrialNudge sub={sub} />
    </>
  );
};
